import React from "react";
import { useTranslation } from "react-i18next";
import PageHelmet from "../common/Helmet";
import Header from "../common/Header";
import Breadcrumb from "../common/Breadcrumb";
import FooterTwo from "../common/FooterTwo";
import EvidenceNetwork from "./EvidenceNetwork";

/** Standalone /evidence/graph page: site chrome around the embeddable
 *  EvidenceNetwork (which owns the radial, drawer, URL sync and the
 *  Search|Network mode toggle). */

const GraphLab = () => {
  const { t } = useTranslation();
  const section = t("evidence.graphTitle", "Evidence network");

  return (
    <>
      <PageHelmet pageTitle={section} />
      <Header />
      <Breadcrumb backgroundSection="About" title={section} />

      <div className="designer-portfolio-area ptb--120 bg_color--1">
        <div className="wrapper plr--70 plr_sm--30 plr_md--30">
          <EvidenceNetwork />
        </div>
      </div>

      <FooterTwo />
    </>
  );
};

export default GraphLab;
